<div class="flex flex-col w-full">
  <div class="aup-background-gray px-6 flex items-center justify-between">
    <h2 class="!p-0 w-2/3 md:w-auto" mat-dialog-title>{{ 'VERIFY_USER_PHONE_MODAL.TITLE' | transloco }}</h2>
    <button (click)="onClose()" mat-icon-button>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div class="flex flex-col pb-4">
    <aup-notification-bar
      class="mt-2 px-6"
      title="{{ 'VERIFY_USER_PHONE_MODAL.TITLE' | transloco }}"
      message="{{
        (data.userPhoneNumberStatus === eUserPhoneNumberStatus.MISSING
          ? 'VERIFY_USER_PHONE_MODAL.MESSAGE.MISSING'
          : 'VERIFY_USER_PHONE_MODAL.MESSAGE.UNVERIFIED'
        ) | transloco
      }}"
      [dismissable]="false"
    ></aup-notification-bar>

    <div>
      <mat-divider></mat-divider>
    </div>

    <div class="flex !justify-start !mt-4 !px-6" mat-dialog-actions>
      <button mat-flat-button color="primary" (click)="onVerifyPhone()">
        {{
          (data.userPhoneNumberStatus === eUserPhoneNumberStatus.MISSING
            ? 'VERIFY_USER_PHONE_MODAL.BUTTON.INSERT_PHONE'
            : 'VERIFY_USER_PHONE_MODAL.BUTTON.VERIFY_PHONE'
          ) | transloco
        }}
      </button>
      <button (click)="onClose()" mat-stroked-button class="aup-btn-stroked-primary">
        {{ 'COMMON.BUTTON.CLOSE' | transloco }}
      </button>
    </div>
  </div>
</div>
